import React from 'react';
import { AiOutlineAudioMuted } from 'react-icons/ai';

const VoiceStop = ({ onClick }) => {
  return <AiOutlineAudioMuted className='stop-icon' onClick={onClick} />;
};

export default VoiceStop;
